/**
 * Admin-half of epic #2628 "Waitlist surfaces" (re-dispatch of C1). Mirrors
 * `manage-event-waitlist-api`'s `GET manage-event-waitlist-api/list` response
 * row — the per-event `EventWaitlist` (prisma/schema.prisma ~L1792,
 * ADR-0026), NOT the marketing `Waitlist` model (which stays PII-locked /
 * anti-enumeration by design, #2920).
 *
 * `notifiedAt` is derived server-side from `EventWaitlist.deletedAt` (ADR-0026
 * / `WaitlistNotificationsService`: a notified row is retired the same way a
 * TTL-swept one is) — `null` means still on the live waitlist ("Waiting"),
 * a timestamp means retired ("Notified" in the admin table's status pill).
 */
export interface EventWaitlistRowI {
  id: string;
  testingEventId: string;
  eventName: string;
  eventStartsAt: string;
  email: string;
  joinedAt: string;
  notifiedAt: string | null;
}

/** Paginated response shape for `GET manage-event-waitlist-api/list`. */
export interface EventWaitlistListI {
  items: EventWaitlistRowI[];
  total: number;
  page: number;
  pageSize: number;
}

/**
 * Page size applied when the client sends no `pageSize` at all. Shared here
 * (not duplicated as separate `25` literals) so `manage-event-waitlist-api`'s
 * `FindEventWaitlistQueryDto` and the admin `ManageWaitlistStore` request the
 * same default page — backend libs already import `@bodyanalytics/data-models-ui`
 * at runtime (e.g. `manage-events-api.service.ts`), so this needs no new
 * cross-boundary dependency.
 */
export const EVENT_WAITLIST_DEFAULT_PAGE_SIZE = 25;
